import LeftLeafSVG from '../../icons/LeftLeafSVG'
import RightLeafSVG from '../../icons/RightLeafSVG'

export default function TopLogo() {
  return (
    <div className='flex items-center mt-1'>
      <LeftLeafSVG />
      <span className='text-status-text-out-of-form text-base font-medium'>Regular to Direct Plan</span>
      <RightLeafSVG />
    </div>
  )
}
